module.exports = __webpack_public_path__ + "img/testi3.6fed554d.svg";